import React from "react";
class User extends React.Component {
  constructor(props) {
    super(props);
    console.log(props);
    this.state={
      count:0,
      count1:0
    }
  }
  render() {
    const { name, age } = this.props;
    const {count,count1}=this.state;

    return (
      <div className="user">
      <button onClick={()=>{
        this.setState(
         { count : count+1,
           count1:count1+1
         }
        )
      }} >Increase</button>
       <button onClick={()=>{
        this.setState(
         { count : count-1,
           count1:count1-1
         }
        )
      }} > Decrease</button>
        <h1>count:{count}</h1>
        <h2>count1:{count1}</h2>
      </div>
    );
  }
}

export default User;
